<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center justify-space-between>
        <div>
          <v-flex xs12>
            <v-breadcrumbs :items="breadcrumbs">
              <template v-slot:item="props">
                <router-link
                  :to="props.item.href"
                  :is="props.item.disabled ? 'span' : 'router-link'"
                >
                  {{ props.item.text }}
                </router-link>
              </template>
              <template v-slot:divider>
                <v-icon>chevron_right</v-icon>
              </template>
            </v-breadcrumbs>
          </v-flex>
          <v-flex xs12>
            <BoxIcon padding="7px 7px 0px 6px" class="mr-3">
              <img
                style="margin-left: 3px"
                :src="require('@/assets/icons/autorizar.svg')"
              />
            </BoxIcon>
            <h1 style="display: inline">Detalle de pase de salida</h1>
          </v-flex>
        </div>
        <div>
          <span class="font-weight-medium">{{ name }}</span>
          <br />
          <div>
            <p class="font-weight-medium">
              <span class="max_text_w"> Fecha de inicio </span>
              <v-icon color="black" size="17" class="ml-3 mr-1">event</v-icon>
              <span class="font-weight-medium">{{ startDate }}</span>
            </p>

            <p v-if="endDate !== undefined" class="font-weight-medium">
              <span class="max_text_w"> Fecha de fin </span>
              <v-icon color="black" size="17" class="ml-3 mr-1">event</v-icon>
              <span class="font-weight-medium">{{ endDate }}</span>
            </p>
          </div>
        </div>
      </v-layout>
    </v-toolbar>
    <v-container
      fluid
      grid-list-xl
      style="
        padding: 20px;
        height: 90vh;
        overflow: scroll;
        padding-bottom: 180px !important;
      "
    >
      <v-layout row wrap>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 sm4 md3>
                  <v-text-field
                    label="Buscar"
                    class="border-container"
                    prepend-inner-icon="search"
                    clearable
                    solo
                    flat
                    hide-details
                    v-model="search"
                    @keyup.enter="getDetailAuthorization"
                    @click:clear="clearSearch"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 style="padding: 0 12px 10px">
          <v-card flat class="border-container">
            <v-card-text class="px-0 py-0">
              <v-data-table
                :rows-per-page-items="[25, 50, 100]"
                rows-per-page-text="Registros por página"
                :headers="headers"
                :items="items"
                :total-items="totalItems"
                :loading="isLoading"
                :pagination.sync="pagination"
                @update:pagination="getDetailAuthorization"
                no-results-text="No se encontraron coincidencias"
                no-data-text="No hay registros"
                must-sort
              >
                <template v-slot:headers="props">
                  <tr>
                    <td v-for="header in props.headers">
                      {{ header.text }}
                    </td>
                  </tr>
                </template>
                <template v-slot:items="props">
                  <tr class="body-2 font-weight-regular">
                    <td>
                      <v-avatar
                        :tile="false"
                        size="30"
                        color="grey lighten-4"
                        v-if="
                          props.item.imageStorage &&
                          props.item.imageStorage.miniObjUrl
                        "
                      >
                        <img
                          :src="props.item.imageStorage.miniObjUrl"
                          alt="avatar"
                        />
                      </v-avatar>
                      <v-avatar v-else text-color="white">
                        <v-icon>account_circle</v-icon>
                      </v-avatar>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{ props.item.firstName }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{ props.item.lastName }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        {{ props.item.level }}
                      </CustomTooltipOverflowText>
                    </td>
                    <td>
                      <CustomTooltipOverflowText>
                        <div>
                          {{ `${props.item.grade} ${props.item.group}` }}
                        </div>
                      </CustomTooltipOverflowText>
                    </td>
                    <td>{{ props.item.personId }}</td>
                  </tr>
                </template>
                <v-progress-linear
                  v-slot:progress
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template v-slot:no-data>
                  <div>No hay registros para filtrar</div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import BoxIcon from '../../../generic/boxIcon.vue'
import CustomTooltipOverflowText from '../../../generic/custom_tooltip_overflow_text.vue'
export default {
  components: {
    CustomTooltipOverflowText,
    BoxIcon,
  },
  data: () => ({
    headers: [
      {
        text: 'Foto',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Nombre Alumno',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Apellido Alumno',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Nivel',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Grupo',
        sortable: false,
        align: 'center',
      },
      {
        text: 'Matrícula',
        sortable: false,
        align: 'center',
      },
    ],
    items: [],
    totalItems: 0,
    isLoading: false,
    pagination: {
      page: 1,
      rowsPerPage: 25,
    },
    search: '',
    breadcrumbs: [
      {
        text: 'Pases de salida',
        disabled: false,
        href: '/es/panel/authorizations',
      },
      {
        text: 'Detalle',
        disabled: true,
        href: '/es/panel/authorizations/detail',
      },
    ],
    name: '',
    startDate: undefined,
    endDate: undefined,
  }),
  mounted() {
    this.setup()
  },
  methods: {
    async getDetailAuthorization() {
      const params = {
        size: this.pagination.rowsPerPage,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        search: this.search === '' ? undefined : this.search,
      }

      try {
        const { data } = await this.$store.dispatch(
          'authorizations/detailAuthorization',
          { idAuthorization: this.$route.params.id, params }
        )

        this.items = data.data
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
      } finally {
      }
    },
    async setup() {
      try {
        const { data } = await this.$store.dispatch(
          'authorizations/getAuthorization',
          this.$route.params.id
        )

        if (data.date !== undefined) {
          this.startDate = this._timeParseCapitalize(this._parseTime(data.date))
        } else {
          this.startDate = this._timeParseCapitalize(
            this._parseTime(data.startDate)
          )
          this.endDate = this._timeParseCapitalize(
            this._parseTime(data.endDate)
          )
        }

        this.name = data.name
      } catch (error) {
        console.log(error)
      }
    },
    _timeParseCapitalize(time = '') {
      const [day, month, year] = time.split('/')
      const capitalMonth = `${month
        .substring(0, 1)
        .toUpperCase()}${month.substring(1)}`

      return `${day}/${capitalMonth}/${year}`
    },
    /**
     * Return a date like so `24/Jul/2023 `
     */
    _parseTime(date) {
      return moment(new Date(date)).format('DD/MMM/YYYY').replaceAll('.', '')
      // .tz(this.getBrandTZ.timezone)
    },
    clearSearch() {
      this.search = ''
      this.getDetailAuthorization()
    },
  },
}
</script>

<style scoped>
.max_text_w {
  width: 100px;
  display: inline-block;
}
.border-container {
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
  overflow: hidden;
}

::v-deep .v-input__prepend-outer {
  margin-right: -1px !important;
}

::v-deep .padded .v-input__slot {
  padding-left: 8px !important;
}

::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  background-color: #f9fafb;
  height: 40px;
}
::v-deep .v-datatable.v-table > thead tr {
  background-color: #dddddd;
  text-transform: initial !important;
  color: #6b7280;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  white-space: nowrap;
}

::v-deep .v-datatable.v-table > tbody {
  max-height: 50vh;
}
::v-deep .v-datatable.v-table > tbody tr td {
  text-align: center;
  font-size: inherit;
  font-weight: inherit;
}
::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

@media (max-width: 600px) {
  ::v-deep .v-datatable.v-table > thead {
    display: block;
  }
}
</style>
